export const URLS = {
  CONTACT: 'https://skygrid.co.jp/contact/',
} as const;

export const PROGRAM_STATS = {
  MAX_SUBSIDY_RATE: '75%',
  MIN_COST_PER_PERSON: '10万円〜',
  TOTAL_HOURS: '10時間',
  TOTAL_SESSIONS: '全3回',
} as const;

export const COMPANY_INFO = {
  NAME: 'Sky Grid Inc.',
  PROGRAM_NAME: 'AI/DX人材育成プログラム',
} as const;
